import { render, staticRenderFns } from "./ImportHistoryDetails.vue?vue&type=template&id=e2ce5438"
import script from "./ImportHistoryDetails.vue?vue&type=script&lang=js"
export * from "./ImportHistoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports